<template>
  <div class="kazang-mobile-money">
    <div class="redirect-card">
      <div class="redirect-content">
        <div class="redirect-icon">
          <img src="@/assets/Kazang.png" alt="Kazang" />
        </div>

        <h3 class="redirect-title">Redirecting to Payment Gateway</h3>
        <p class="redirect-message">
          You will be redirected to the Kazang payment gateway to complete your payment securely.
        </p>

        <div class="payment-summary">
          <span class="summary-label">Amount to Pay</span>
          <span class="summary-value">{{ $utils.formatMoney(reference.amount) }}</span>
        </div>

        <div class="redirect-spinner">
          <div class="spinner"></div>
          <span class="spinner-text">{{ statusText }}</span>
        </div>

        <p v-if="error" class="error-message">
          {{ error }}
          <button type="button" class="retry-button" @click="initiatePayment">
            Try Again
          </button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import paymentService from '@/services/paymentService'

export default {
  name: 'KazangMobileMoney',
  props: {
    reference: {
      type: Object,
      required: true
    },
    referenceId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isRedirecting: false,
      error: null,
      statusText: 'Preparing payment...'
    }
  },
  mounted() {
    this.initiatePayment()
  },
  methods: {
    async initiatePayment() {
      this.isRedirecting = true
      this.error = null
      this.statusText = 'Creating transaction...'

      try {
        const data = await paymentService.createKazangTransaction(this.reference, this.referenceId)
        this.statusText = 'Redirecting to Kazang...'

        // Small delay for user to see the status
        setTimeout(() => {
          const redirectUrl = paymentService.getKazangRedirectUrl(data.ID)
          window.open(redirectUrl, '_self')
        }, 500)
      } catch (err) {
        this.isRedirecting = false
        this.error = err.message || 'Failed to create payment. Please try again.'
        window.errorHandler.tomcatError(err)
      }
    }
  }
}
</script>

<style scoped>
.kazang-mobile-money {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.redirect-card {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 0.75rem;
  padding: 2rem;
}

.redirect-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.redirect-icon {
  width: 64px;
  height: 64px;
  background: #f4f4f5;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem;
}

.redirect-icon img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.redirect-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #18181b;
  margin: 0 0 0.5rem 0;
}

.redirect-message {
  font-size: 0.875rem;
  color: #71717a;
  line-height: 1.5;
  margin: 0 0 1.5rem 0;
  max-width: 300px;
}

.payment-summary {
  background: #f4f4f5;
  border-radius: 0.5rem;
  padding: 1rem 1.5rem;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.summary-label {
  font-size: 0.75rem;
  color: #71717a;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.summary-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0ea5e9;
}

.redirect-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}

.spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e4e4e7;
  border-top-color: #0ea5e9;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.spinner-text {
  font-size: 0.875rem;
  color: #71717a;
}

.error-message {
  color: #dc2626;
  font-size: 0.875rem;
  margin: 1rem 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}

.retry-button {
  background: #18181b;
  color: #ffffff;
  border: none;
  font-size: 0.8125rem;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: background 0.2s;
}

.retry-button:hover {
  background: #27272a;
}
</style>
